<div style="width: 100%" class="page-borders">
    <div class="m-5 flex flex-row">
        <div class="page-header">Workbench</div>
    </div>
    <mat-tab-group [selectedIndex]="selectedTabIndex" class="inner-mat-tab mat-tab-no-border m-5">
        
        <mat-tab label="Requirements">
            <ng-template matTabContent>
                <workbenchv2-requirements-config [client]="client"
                    [account]="account"></workbenchv2-requirements-config>
            </ng-template>
        </mat-tab>
        <mat-tab label="Tasks" *ngIf="isTasksEnabled">
            <ng-template matTabContent>
                <workbenchv2-tasks-config [client]="client" [account]="account"></workbenchv2-tasks-config>
            </ng-template>
        </mat-tab>
        <mat-tab label="Options">
            <ng-template matTabContent>
                <workbenchv2-options-config [client]="client" [account]="account"></workbenchv2-options-config>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>